import AgencyService from 'services/agenciesService';
import { ContractSettings } from 'types/agencySettings';

const getContractSettings = async (
  getAuthToken: () => Promise<string>,
  agencyId?: string
): Promise<ContractSettings | undefined> => {
  if (!agencyId) return;

  const token = await getAuthToken();
  const service = new AgencyService(token);

  const result = await service.agencyService.get('GetContractSettings', {
    agencyId,
  });

  return result.data;
};

export default getContractSettings;
